/* Comfrt-style wishlist hearts on product cards, wired to Swym Wishlist Plus.
   Heart lives top-right of each .cpc-card photo; fills when the product is saved. */
(function () {
  var wished = {}; // product id (empi, as string) -> true

  function whenSwym(cb) {
    // Poll for Swym readiness — avoids a race where Swym fires onLoad before this script registers.
    if (window._swat && typeof window._swat.fetch === 'function') { cb(); return; }
    var n = 0;
    var iv = setInterval(function () {
      if (window._swat && typeof window._swat.fetch === 'function') { clearInterval(iv); cb(); }
      else if (++n > 100) { clearInterval(iv); } // give up after ~20s
    }, 200);
  }

  function di(btn) {
    var du = btn.getAttribute('data-du') || '';
    if (!/^https?:/i.test(du)) du = window.location.origin + du; // Swym requires an absolute URL
    return {
      epi: parseInt(btn.getAttribute('data-epi'), 10),
      empi: parseInt(btn.getAttribute('data-empi'), 10),
      du: du,
      iu: btn.getAttribute('data-iu'),
      dt: btn.getAttribute('data-dt'),
      pr: parseFloat(btn.getAttribute('data-pr')) || 0
    };
  }

  function paint() {
    document.querySelectorAll('.cpc-wish').forEach(function (b) {
      b.classList.toggle('is-active', !!wished[b.getAttribute('data-empi')]);
    });
  }

  function refresh() {
    if (!(window._swat && window._swat.fetch)) return;
    window._swat.fetch(function (items) {
      wished = {};
      (items || []).forEach(function (it) { if (it && it.empi != null) wished[String(it.empi)] = true; });
      paint();
    }, function () {});
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.cpc-wish') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (!window._swat) return;
    var d = di(btn), key = String(d.empi), isOn = !!wished[key];
    wished[key] = !isOn;
    btn.classList.toggle('is-active', !isOn); // optimistic
    if (isOn) {
      window._swat.removeFromWishList(d, function () {}, function () { wished[key] = true; btn.classList.add('is-active'); });
    } else {
      window._swat.addToWishList(d, function () {}, function () { wished[key] = false; btn.classList.remove('is-active'); });
    }
  }, true);

  // Header wishlist icon opens the Swym wishlist (its floating launcher is hidden via CSS)
  document.addEventListener('click', function (e) {
    var w = e.target.closest ? e.target.closest('.hv-wishlist') : null;
    if (!w) return;
    e.preventDefault();
    var launcher = document.querySelector('#swym-anchor a') || document.querySelector('#swym-anchor');
    if (launcher) launcher.click();
    else window.location.hash = 'swym-wishlist';
  }, true);

  whenSwym(refresh);

  // Re-paint hearts that load later (collection filtering / pagination)
  if (window.MutationObserver) {
    var pending = false;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) {
          if (!pending) { pending = true; setTimeout(function () { pending = false; paint(); }, 200); }
          break;
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();

/* ----------------------------------------------------------------------------
   CRO gallery guard + diagnostic — keeps the first/active product photo visible
   on mobile no matter what hides it, and (only if it still goes gray) shows a
   small on-page readout naming the exact cause. Scoped to product pages.
---------------------------------------------------------------------------- */
(function () {
  if (!document.body || document.body.className.indexOf('template-product') === -1) return;
  var gallery = document.querySelector('[data-js-product-gallery]');
  if (!gallery) return;

  var origs = new WeakMap();        // remember each img's original src/srcset
  var fixes = 0, lastFix = '';

  function imgs() { return gallery.querySelectorAll('.product-gallery-item img'); }

  function guard() {
    var list = imgs();
    for (var i = 0; i < list.length; i++) {
      var img = list[i];
      var item = img.closest('.product-gallery-item');
      var fig = img.closest('.lazy-image');

      // remember a good src/srcset the first time we see one
      if (!origs.has(img)) {
        var s = img.getAttribute('src'), ss = img.getAttribute('srcset');
        if (s || ss) origs.set(img, { src: s, srcset: ss });
      }
      // restore an emptied src/srcset
      var o = origs.get(img);
      if (o && !img.getAttribute('src') && !img.getAttribute('srcset')) {
        if (o.srcset) img.setAttribute('srcset', o.srcset);
        if (o.src) img.setAttribute('src', o.src);
        fixes++; lastFix = 'src';
      }
      // satisfy the theme's reveal gate
      if (fig && !fig.classList.contains('lazyloaded')) { fig.classList.add('lazyloaded'); fixes++; lastFix = 'lazyloaded'; }

      var cs = getComputedStyle(img);
      if (parseFloat(cs.opacity) < 0.99) { img.style.setProperty('opacity', '1', 'important'); fixes++; lastFix = 'opacity'; }
      if (cs.visibility === 'hidden') { img.style.setProperty('visibility', 'visible', 'important'); fixes++; lastFix = 'visibility'; }
      if (cs.display === 'none') { img.style.setProperty('display', 'block', 'important'); fixes++; lastFix = 'display'; }

      // for the first photo and the active slide, clear any transform that hides it
      var isFirst = item && item.getAttribute('data-index') === '0';
      var isActive = item && item.classList.contains('css-slide-active');
      if ((isFirst || isActive) && cs.transform && cs.transform !== 'none') {
        img.style.setProperty('transform', 'none', 'important'); fixes++; lastFix = 'transform';
      }

      // THE real bug: the mobile slider collapses the item to 0px tall, so the photo is
      // full-width but zero-height → gray. Force a real square height when that happens.
      var ir = img.getBoundingClientRect();
      if (item && ir.width > 10 && ir.height < 4) {
        var sq = Math.round(item.getBoundingClientRect().width || ir.width);
        item.style.setProperty('aspect-ratio', '1 / 1', 'important');
        item.style.setProperty('padding-top', '0', 'important');
        item.style.setProperty('height', 'auto', 'important');
        if (fig) { fig.style.setProperty('height', sq + 'px', 'important'); fig.style.setProperty('padding-top', '0', 'important'); }
        img.style.setProperty('height', sq + 'px', 'important');
        fixes++; lastFix = 'height-collapse';
      }
    }
  }

  function tick() { guard(); }

  var fast = setInterval(tick, 150);
  setTimeout(function () { clearInterval(fast); setInterval(tick, 800); }, 25000);
  if (window.MutationObserver) {
    new MutationObserver(tick).observe(gallery, { attributes: true, childList: true, subtree: true, attributeFilter: ['style', 'class', 'src', 'srcset'] });
  }
  tick();
})();

/* Offer banner — tap the promo-code pill to APPLY the discount to the cart in one tap.
   This applies it in the background (no navigation) so it's already on at checkout and the
   customer never leaves to hunt for a code (the #1 discount-driven checkout-abandon trigger).
   Confirms with a persistent "Applied!" state; also copies the code as a harmless fallback. */
(function () {
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-fst-offer-code]') : null;
    if (!b) return;
    var code = b.getAttribute('data-fst-offer-code') || '';
    if (!code || b.getAttribute('data-fst-applied') === '1') return; // ignore repeat taps
    b.setAttribute('data-fst-applied', '1');
    b.classList.add('is-applying');
    fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
      .then(function () { b.classList.remove('is-applying'); b.classList.add('is-applied'); })
      .catch(function () { b.classList.remove('is-applying'); b.classList.add('is-applied'); });
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).catch(function () {});
    }
  });
})();

/* Abbreviate full-word sizes (Small -> S, X-Large -> XL, etc.) on variant BUTTONS site-wide so
   the label never overflows the button. Display-only — the radio input's value is left untouched,
   and only known size words are changed (numeric/already-letter/other options are skipped). */
(function () {
  var MAP = { 'EXTRA SMALL':'XS','X-SMALL':'XS','XSMALL':'XS','SMALL':'S','MEDIUM':'M','LARGE':'L','EXTRA LARGE':'XL','X-LARGE':'XL','XLARGE':'XL','XX-LARGE':'2XL','2X-LARGE':'2XL','XXLARGE':'2XL','XXX-LARGE':'3XL','3X-LARGE':'3XL','XXXX-LARGE':'4XL','4X-LARGE':'4XL' };
  function run() {
    var labels = document.querySelectorAll('.product-variant__item--radio:not(.product-variant__item--color) > label');
    for (var i = 0; i < labels.length; i++) {
      var l = labels[i];
      if (l.children.length || l.dataset.fstAbbr) continue;
      var t = l.textContent.trim();
      var a = MAP[t.toUpperCase()];
      if (a && a !== t) l.textContent = a;
      l.dataset.fstAbbr = '1';
    }
  }
  var pending = false;
  function schedule() { if (pending) return; pending = true; requestAnimationFrame(function () { pending = false; run(); }); }
  function boot() { run(); try { new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true }); } catch (e) {} }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

/* AfterSell PDP upsell lives in a shadow DOM, so the theme's CSS can't reach it. Inject
   brand-matching styles INTO that shadow root so its cards + add-to-cart button look like
   the rest of the site. Re-applies if AfterSell re-renders. */
(function () {
  var CSS = [
    '.pdp-widget, .pdp-widget * { font-family: Helvetica, Arial, sans-serif !important; }',
    '.product-image-wrapper, .product-image, .product-card { border-radius: 10px !important; }',
    '.product-title { font-size: 15px !important; font-weight: 700 !important; color:#1a1a1a !important; text-transform:none !important; }',
    '.price-info { color:#1a1a1a !important; font-weight:700 !important; }',
    '.price-info.compare-at-price { text-decoration: line-through !important; opacity:.5 !important; font-weight:600 !important; }',
    // discount tag: more padding + background follows the selected color swatch (via --fst-atc-color, set on the host by the theme color script)
    '.discount-label { background: var(--fst-atc-color, #1a1a1a) !important; color: var(--fst-atc-text, #fff) !important; border-radius:7px !important; text-transform:uppercase !important; font-weight:700 !important; letter-spacing:.04em !important; padding:5px 12px !important; display:inline-block !important; width:auto !important; }',
    '.select-dropdown, .select-wrap { border-radius:10px !important; }',
    // "Add bundle to cart" follows the selected swatch color, like the main Add-to-Cart button
    '.add-button { background: var(--fst-atc-color, #1a1a1a) !important; color: var(--fst-atc-text, #fff) !important; border:0 !important; border-radius:12px !important; font-family:Helvetica,Arial,sans-serif !important; font-weight:700 !important; font-size:16px !important; text-transform:uppercase !important; letter-spacing:.02em !important; padding:14px 20px !important; width:100% !important; }',
    '.add-button:hover { opacity:.88 !important; }'
    // (Bundle stays vertical/stacked — it now lives in the narrow right info column, like Comfrt.)
  ].join('\n');

  function styleHost(host) {
    var sr = host.shadowRoot;
    if (sr && !sr.querySelector('#fst-aftersell-style')) {
      var st = document.createElement('style');
      st.id = 'fst-aftersell-style';
      st.textContent = CSS;
      sr.appendChild(st);
      if (window.MutationObserver) {
        new MutationObserver(function () {
          if (!sr.querySelector('#fst-aftersell-style')) sr.appendChild(st.cloneNode(true));
        }).observe(sr, { childList: true });
      }
    }
    // sync the swatch color into the shadow DOM (custom props on the host inherit across the boundary)
    if (window.__fstAtc) {
      host.style.setProperty('--fst-atc-color', window.__fstAtc.c);
      host.style.setProperty('--fst-atc-text', window.__fstAtc.t);
    }
  }

  var tries = 0, everFound = false;
  var iv = setInterval(function () {
    tries++;
    var hosts = document.querySelectorAll('[id*="aftersell"]');
    if (hosts.length) everFound = true;
    hosts.forEach(function (host) { if (host.shadowRoot) styleHost(host); });
    if (tries > 60 || (tries > 12 && !everFound)) clearInterval(iv);
  }, 300);
})();
